import styled from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => `
    color: ${theme.color.white};

    svg path {
      stroke: ${theme.color.white};
    }
  `}
`

export const BranchWrapper = styled.div``

type TitleProps = {
  isDroppedDown?: boolean
}

export const Title = styled.div<TitleProps>`
  display: flex;
  align-items: center;
  transition: color 0.3s ease;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};

    &:hover {
      color: ${theme.color.oceanLight};

      svg {
        path {
          stroke: ${theme.color.oceanLight};
        }
      }
    }

    p[data-selector='Typography'] {
      flex: 1 0;
      font-weight: ${theme.fontWeight.bold};
      padding-right: ${theme.space.mobile.tiny};
      padding: ${theme.space.mobile.nano} 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    svg {
      flex-shrink: 0;
      width: 15px;
      height: 100%;
      margin-left: auto;
      transform-origin: 50% 50%;
      transform: rotateX(0);
      transition: all 0.3s ease;

      path {
        transition: color 0.3s ease;
      }
    }
  `}

  ${({ theme, isDroppedDown }) =>
    isDroppedDown &&
    `
    color: ${theme.color.oceanLight};

    svg {
      transform: rotateX(180deg);

      path {
        stroke: ${theme.color.oceanLight};
      }
    }
  `}
`

export const Counter = styled.span`
  display: inline-block;
  position: relative;

  ${({ theme }) => `
    color: ${theme.color.black};
    background: ${theme.color.gold};
    border-radius: ${theme.borderRadius.small};
    margin-left: ${theme.space.mobile.tiny};
    padding: 0 ${theme.space.mobile.nano};

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 100%;
      width: 0;
      height: 0;
      border-top: 5px solid ${theme.color.mustard};
      border-left: 5px solid transparent;
    }
  `}
`

type ListProps = {
  isShown: boolean
}

export const List = styled.ul<ListProps>`
  margin: 0;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;

  ${({ theme }) => `
    padding-left: ${theme.space.mobile.small};
  `}

  ${({ isShown }) =>
    isShown &&
    `
    max-height: 500px;
    transition: max-height 1.2s ease-out;
  `}
`

export const ListItem = styled.li`
  list-style: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.3s ease;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.small};

    &:hover {
      color: ${theme.color.oceanLight};
    }
  `}
`
